const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const _doRequest = (method, url, body, timeout) => new Promise((resolve) => {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, true);
  xhr.withCredentials = true;
  if (body && !(body instanceof FormData)) {
    xhr.setRequestHeader("Content-Type", "application/json");
  }
  xhr.onload = () => {
    let data = {};
    try { data = JSON.parse(xhr.responseText); } catch {}
    resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, data });
  };
  xhr.onerror = () => resolve({ ok: false, status: 0, data: { detail: "Error de red" } });
  xhr.ontimeout = () => resolve({ ok: false, status: 0, data: { detail: "Timeout" } });
  xhr.timeout = timeout;
  xhr.send(body instanceof FormData ? body : body ? JSON.stringify(body) : null);
});

export const apiCall = async (method, url, body = null) => {
  const result = await _doRequest(method, url, body, 30000);
  // Auto-retry once for GET requests on network/timeout failure
  if (!result.ok && result.status === 0 && method === "GET") {
    await new Promise(r => setTimeout(r, 2000));
    return _doRequest(method, url, body, 15000);
  }
  return result;
};

export const formatDate = (dateString) => {
  if (!dateString) return "\u2014";
  try {
    return new Date(dateString).toLocaleDateString("es-AR", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit"
    });
  } catch { return "\u2014"; }
};

export const COUNTRIES = [
  { code: "AR", name: "Argentina", flag: "\ud83c\udde6\ud83c\uddf7" },
  { code: "BR", name: "Brasil", flag: "\ud83c\udde7\ud83c\uddf7" },
  { code: "CL", name: "Chile", flag: "\ud83c\udde8\ud83c\uddf1" },
  { code: "CO", name: "Colombia", flag: "\ud83c\udde8\ud83c\uddf4" },
  { code: "MX", name: "M\u00e9xico", flag: "\ud83c\uddf2\ud83c\uddfd" },
  { code: "PE", name: "Per\u00fa", flag: "\ud83c\uddf5\ud83c\uddea" },
  { code: "UY", name: "Uruguay", flag: "\ud83c\uddfa\ud83c\uddfe" },
  { code: "US", name: "Estados Unidos", flag: "\ud83c\uddfa\ud83c\uddf8" },
  { code: "ES", name: "Espa\u00f1a", flag: "\ud83c\uddea\ud83c\uddf8" },
];
